import { StateKeysArrayType } from './types'

export const WHITE_LISTED_REDUCERS: StateKeysArrayType = []
